import React, { useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Layout from "./Layout";
import Hero from "./Hero";
import Styles from "../../public/assets/css/main.css";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

const Home = () => {
  const context = useContext(AppContext);
  const intl = useIntl();

  useEffect(() => {
    if (context) {
      // context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  return (
    <Layout>
      <Hero />
    </Layout>
  );
};

export default Home;
